export default __webpack_public_path__ + "static/media/IMG-20210326-WA0049.de1daed7.jpg";